import { render, staticRenderFns } from "./roucePlay2.vue?vue&type=template&id=9a489a76"
import script from "./roucePlay2.vue?vue&type=script&lang=js"
export * from "./roucePlay2.vue?vue&type=script&lang=js"
import style0 from "./roucePlay2.vue?vue&type=style&index=0&id=9a489a76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports